import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { ExportableFile } from "@/ExportableFile/Models/ExportableFile";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { PortalSyncMode } from "@/Portal/Models/PortalSyncMode";
import { BaseSendToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendToPortalPopupStrategy";
import { ISignAndSendToPortalPopupStrategy } from "./ISendToPortalPopupStrategy";

export abstract class BaseSendMedicalNoteItemToPortalPopupStrategy extends BaseSendToPortalPopupStrategy implements ISignAndSendToPortalPopupStrategy {
    private readonly _onSignatureAccepted: () => void;
    private readonly _onSignatureRejected: () => void;
    private readonly _onRemoveSignature: () => void;

    protected readonly portalPopupModel: PortalPopupModel;

    public abstract get isSignatureRequired(): boolean;
    public abstract get signableFile(): ExportableFile | string;

    public get shouldShowFilePreview(): boolean {
        return this.sharedItemCanBeSigned;
    }

    public get sharedItemCanBeSigned(): boolean {
        return this.portalPopupModel.syncMode === PortalSyncMode.SignAndSync;
    }

    public get shouldExportSignedFile(): boolean {
        const mode = this.portalPopupModel.syncMode;
        return mode === PortalSyncMode.SignAndSync
            || mode === PortalSyncMode.SkipSignAndSync;
    }

    constructor(
        linkedItemType: PortalLinkedItemType,
        revokeClickOperation: number,
        closePopupClickOperation: number,
        portalPopupModel: PortalPopupModel,
        onSignatureAccepted: () => void,
        onSignatureRejected: () => void = null,
        onRemoveSignature: () => void = null
    ) {
        super(linkedItemType, revokeClickOperation, closePopupClickOperation);

        this.portalPopupModel = portalPopupModel;
        this._onSignatureAccepted = onSignatureAccepted;
        this._onSignatureRejected = onSignatureRejected;
        this._onRemoveSignature = onRemoveSignature;
    }

    public onSignatureAccepted(): void {
        this._onSignatureAccepted?.();
    }

    public onSignatureRejected(): void {
        this._onSignatureRejected?.();
    }

    public onRemoveSignature(): void {
        this._onRemoveSignature?.();
    }
}
